import TabBar from 'antd-mobile/lib/tab-bar';
export default TabBar;



// WEBPACK FOOTER //
// ./components/tab-bar/index.tsx